module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/milk-shake_44c588.jpg";